// Widget Scripts
import cardWidget from './js/widgets/cardWidget';
import circularWidget from './js/widgets/circularWidget';
import dailySchedule from './js/widgets/dailySchedule';
import featuredEvent from './js/widgets/featuredEvent';
import footerColumn1 from './js/widgets/footerColumn1';
import footerColumn2 from './js/widgets/footerColumn2';
import footerColumn3 from './js/widgets/footerColumn3';
import headerButtons from './js/widgets/headerButtons';
import headerLinks from './js/widgets/headerLinks';
import headerWidget from './js/widgets/headerWidget';
import hoursLocation from './js/widgets/hoursLocation';
import infoCard from './js/widgets/infoCard';
import mainFeature from './js/widgets/mainFeature';
import membership from './js/widgets/membership';
import multiScheduleFeature from './js/widgets/multiScheduleFeature';
import seoWidget from './js/widgets/seoWidget';
import sponsors from './js/widgets/sponsors';
import support from './js/widgets/support';
import ticketsReservations from './js/widgets/ticketsReservations';
import ticketWidget from './js/widgets/ticketWidget';
import videoWidget from './js/widgets/videoWidget';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    cardWidget();
    circularWidget();
    dailySchedule();
    featuredEvent();
    hoursLocation();
    infoCard();
    mainFeature();
    membership();
    multiScheduleFeature();
    seoWidget();
    support();
    ticketsReservations();
    ticketWidget();
  });

  $(window).load(function() {
    videoWidget();
  });
}

// Initialize Sitewide Widgets
$(document).ready(function() {
  footerColumn1();
  footerColumn2();
  footerColumn3();
  headerButtons();
  headerLinks();
  headerWidget();
  sponsors();
});